var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'molecule-menu-trigger-universe': true, active: _vm.isActive },on:{"click":_vm.toggleSidebar}},[_c('AtomsCommonAtomIcon',{attrs:{"icon":"bars3","size":32,"color":"#000"}}),_vm._v(" "),_c('AtomsCommonAtomIcon',{attrs:{"icon":"xmark","size":32,"color":"#000"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }